import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import SailingIcon from "@mui/icons-material/Sailing";
import SchoolIcon from "@mui/icons-material/School";
import BiotechIcon from "@mui/icons-material/Biotech";
import PeopleIcon from "@mui/icons-material/People";

const details = [
  {
    title: "Marine & Coastal Conservation",
    description:
      "BEF provides support for the government to protect and restore mangrove forests along the Niger Delta, Lagos lagoon, Cross River estuaries, and other coastal zones in the country. Also, the foundation collaborates with the government and coastal communities to create and manage designated Marine Protected Areas (MPAs). In addition, BEF advocates for monitoring coastal pollution, plastic waste, and oil spill remediation. Furthermore, the foundation runs coastal ecosystem restoration projects, planting mangroves, building natural buffers, and deploying oyster reefs for shoreline protection.",
    color: "#317ABE",
    icon: (
      <SailingIcon
        sx={{
          width: 56,
          height: 56,
          "&:hover": { color: "#fff", border: " 2px dotted #9DCC49" },
        }}
      />
    ),
  },
  {
    title: "Sustainable Blue Livelihoods",
    description:
      "BEF develops community-led aquaculture and mariculture programs, targeted at women and youth economic development. Also, the foundation supports coastal seaweed and oyster farming, crab and shrimp culture, and tilapia cage systems in estuarine waters for sustainable livelihood. In addition, BEF partners with institutions to build coastal processing hubs (icing, cold storage, drying, packaging) to reduce post-harvest losses. Furthermore, the foundation uses its platform to promote eco-tourism and coastal heritage enterprises that celebrate local culture and marine biodiversity.",
    color: "#9DCC49",
    icon: (
      <PeopleIcon
        sx={{
          width: 56,
          height: 56,
          "&:hover": { color: "#fff", border: " 2px dotted #9DCC49" },
        }}
      />
    ),
  },
  {
    title: "Blue Policy, Research & Climate Action",
    description:
      "BEF serves as Nigeria’s think tank and advocacy platform for marine and coastal policy reforms. Also, the foundation conducts marine and mangrove biodiversity assessments, stock surveys, and climate impact studies to promote the marine ecosystem. In addition, BEF builds partnerships with international development organizations such as the World Bank, UNDP, WWF, and the African Blue Economy Strategy (AU) to promote the blue economy in Nigeria. Furthermore, the foundation advocates for marine spatial planning, blue carbon credits, and climate-smart coastal cities for a resilient marine ecosystem.",
    color: "#317ABE",
    icon: (
      <BiotechIcon
        sx={{
          width: 56,
          height: 56,
          "&:hover": { color: "#fff", border: " 2px dotted #9DCC49" },
        }}
      />
    ),
  },
  {
    title: "Education, Technology & Community Development ",
    description:
      "BEF promotes ocean literacy through youth-focused Blue Eco-Hubs in coastal states, providing training in aquaculture, seaweed farming, waste recycling, and digital marine mapping. The foundation also partners with universities and research institutes to advance marine science education, drone mapping, and AI-driven coastal monitoring. In addition, BEF implements school and community outreach on ocean literacy and plastic pollution, and leads citizen science initiatives that engage local communities in collecting coastal and biodiversity data to inform policy and decision-making.  ",
    color: "#9DCC49",
    icon: (
      <SchoolIcon
        sx={{
          width: 56,
          height: 56,
          "&:hover": { color: "#fff", border: " 2px dotted #9DCC49" },
        }}
      />
    ),
  },
];

const Pillars = () => {
  return (
    <Box marginBottom={"5%"}>
      <Typography
        variant="h3"
        fontWeight={700}
        paddingBottom={{ xs: "4%", sm: "2%" }}
        textAlign={"left"}
        color={"#317ABE"}
      >
        {" "}
        Our Pillars
      </Typography>
      <Typography
        variant="h6"
        color="#000"
        fontWeight={400}
        paddingBottom={{ xs: "10%", sm: "2%" }}
        lineHeight={1.75}
        textAlign={"left"}
      >
        Our strategic identity is based on four pillars - Marine & Coastal
        Conservation, Sustainable Blue Livelihoods, Blue Policy, Research &
        Climate Action and Education, Technology & Community Development.
      </Typography>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        flexWrap={"wrap"}
        width={{ xs: "100%", sm: "100%" }}
      >
        {details.map((items, index) => (
          <Box
            key={index}
            padding={{ xs: "10% 5%", sm: "2% 2% 5% 2%" }}
            backgroundColor={items.color}
            width={{ xs: "100%", sm: "25%" }}
          >
            <Box marginTop={"15%"}>
              <Avatar
                sx={{
                  bgcolor: "#fff",
                  color: "#9DCC49",
                  width: 96,
                  height: 96,
                }}
              >
                {items.icon}
              </Avatar>
            </Box>
            <Box>
              <Typography
                variant="h5"
                color="#fff"
                fontWeight={700}
                paddingTop={"10%"}
                paddingBottom={"2%"}
                textAlign={"left"}
              >
                {items.title}
              </Typography>
              <Typography
                variant="body1"
                color="#fff"
                fontWeight={400}
                paddingTop={"4%"}
                paddingBottom={{ xs: "10%", sm: "2%" }}
                lineHeight={1.5}
                textAlign={"left"}
              >
                {items.description}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Pillars;
